import React from 'react'
import PropTypes from 'prop-types'
import { formatDate } from 'Shared/helpers'
import { useWhsTerms } from '../whs_terms_context'

const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

const StatPanel = ({ label, value, badge, sub }) => (
  <div className='stat-panel'>
    <div className='stat-panel__label'>{label}</div>
    <div className='stat-panel__value'>
      <span className='stat-panel__number'>{value}</span>
      {badge != null && (
        <span className='stat-panel__badge'>{badge}</span>
      )}
    </div>
    {sub && <div className='stat-panel__sub'>{sub}</div>}
  </div>
)

StatPanel.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sub: PropTypes.string,
}

const HandicapHeader = ({ currentHi, onHiChange, hiChange, activeCount, validThrough, attachedBelow }) => {
  const whsTerms = useWhsTerms()

  return (
  <div className={`handicap-header${attachedBelow ? ' handicap-header--attached' : ''}`}>
    <div className='stat-panel'>
      <div className='stat-panel__label'>{t('member_handicap_history.header.current_hi', whsTerms)}</div>
      <div className='stat-panel__value'>
        {onHiChange ? (
          <input
            type='text'
            className='form-control input-sm hi-input'
            value={currentHi || ''}
            onChange={e => onHiChange(e.target.value)}
          />
        ) : (
          <span className='stat-panel__number'>{currentHi || '—'}</span>
        )}
        {hiChange != null && (
          <span className='stat-panel__badge'>{hiChange}</span>
        )}
      </div>
    </div>
    <StatPanel
      label={t('member_handicap_history.header.active_scores')}
      value={activeCount ?? '—'}
      sub={validThrough ? formatDate(validThrough, null, 'MMM D, YYYY') : undefined}
    />
  </div>
  )
}

HandicapHeader.propTypes = {
  currentHi: PropTypes.string,
  onHiChange: PropTypes.func,
  hiChange: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activeCount: PropTypes.number,
  validThrough: PropTypes.string,
  attachedBelow: PropTypes.bool,
}

HandicapHeader.defaultProps = {
  attachedBelow: false,
}

export default HandicapHeader
